// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { mergeStyles } from '@fluentui/react';

/**
 * @private
 */
export const systemMessageIconStyle = mergeStyles({
  marginInlineEnd: '0.688rem'
});